import React from "react";

import logoObersoundSVG from "../../images/logos/logo-obersound.svg";

const ResponsiveFallback = () => (
  <div className="flex items-center justify-center vh-100">
    <div className="responsive-fallback">
      <div className="responsive-fallback__logo">
        <img src={logoObersoundSVG} alt="OberSound" />
      </div>
      <div className="responsive-fallback__text">
        L'expérience est optimisée pour tablettes et ordinateurs uniquement.
      </div>
    </div>
  </div>
);

export default ResponsiveFallback;



// WEBPACK FOOTER //
// ./src/components/shared/ResponsiveFallback.js